// hooks/useFormViewerWizard/resumeWizardOrder.ts — Pakai lagi order step-1 sesi.
// Mencegah insert ganda (reload/Back → Lanjut) yang memicu DEDUP-cancel order
// Pending sebelumnya. Return {orderId, csId} bila order sesi masih Pending
// wizard_*; selain itu null (caller insert baru). Data step-1 tak diubah
// (nama/WA ikut submit pertama — edit kecil = tugas CS/followup).
import { supabase } from '../../../../supabase/client';
import { getStoredPhoneLast4 } from '../../../../hooks/useThankYouPage/fetchOrder';

export async function resumeWizardOrder(formId: string, cartSig?: string): Promise<{ orderId: string; csId: string | null; stale: boolean } | null> {
    let saved: { orderId?: string; csId?: string | null; sig?: string } | null = null;
    try { saved = JSON.parse(sessionStorage.getItem(`wizardOrder_${formId}`) || 'null'); } catch { saved = null; }
    if (!saved?.orderId) return null;
    // Keranjang berubah (varian/qty beda) -> order draft TETAP dipakai, tapi
    // ditandai `stale` supaya caller mem-PATCH-nya (bukan insert baru -> dedup).
    const stale = !!(cartSig && saved.sig && saved.sig !== cartSig);
    try {
        const last4 = getStoredPhoneLast4(saved.orderId) || undefined;
        const { data, error } = await supabase
            .rpc('get_public_order_limited', { p_order_id: saved.orderId, p_phone_last4: last4 })
            .abortSignal(AbortSignal.timeout(10000));
        const row: any = Array.isArray(data) ? data[0] : data;
        // Syarat: ID cocok (UUID tak tertebak, dari sesi sendiri) + masih Pending.
        // sourceForm SENGAJA tak dicek (get_public_order_limited tak mengembalikannya).
        if (!error && row?.id && row?.status === 'Pending') {
            return { orderId: row.id, csId: saved.csId || null, stale };
        }
    } catch { /* jatuh ke insert baru */ }
    try { sessionStorage.removeItem(`wizardOrder_${formId}`); } catch { /* */ }
    return null;
}
